import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { BreezeEntity } from '../../../../data/services/breeze/breeze.service';
import { TakeOffMeasurement } from '../../domain';
import { TakeOffConfig } from '../feat-take-off-v2/domain';

@Component({
    selector: 'app-take-off-v2-plan-info',
    templateUrl: './take-off-v2-plan-info.component.html',
    styleUrls: ['./take-off-v2-plan-info.component.scss'],
    standalone: false,
})
export class TakeOffV2PlanInfoComponent implements OnChanges, OnInit {
    // @ts-ignore TS2564
    @Input() config: TakeOffConfig;
    // @ts-ignore TS2564
    @Input() plans: BreezeEntity[];
    // @ts-ignore TS2564
    @Input() selectedPlan: BreezeEntity;
    // @ts-ignore TS2564
    @Input() measurement: TakeOffMeasurement;

    @Output() selectedPlanChanges = new EventEmitter<string>();

    // @ts-ignore TS2564
    public planControl: UntypedFormControl;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.planControl && changes.selectedPlan?.currentValue) {
            this.updatePlanControl();
        }
    }

    private updatePlanControl() {
        if (this.planControl.value !== this.selectedPlan.ID_Plan) {
            this.planControl.setValue(this.selectedPlan.ID_Plan);
        }
    }

    ngOnInit(): void {
        this.initForm();
    }

    private initForm() {
        this.planControl = new UntypedFormControl(this.selectedPlan.ID_Plan);

        this.planControl.valueChanges
            .pipe(filter((value) => !!value))
            .subscribe((selectedPlanId: string) => this.onSelectPlan(selectedPlanId));
    }

    private onSelectPlan(selectedPlanId: string) {
        if (selectedPlanId === this.selectedPlan.ID_Plan) {
            return;
        }

        this.selectedPlanChanges.emit(selectedPlanId);
    }
}

@NgModule({
    declarations: [TakeOffV2PlanInfoComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [TakeOffV2PlanInfoComponent],
})
export class TakeOffV2PlanInfoModule {}
